<template>
    <div class="modal" :class="{'is-active':isActiveJetplanWaitingRequestsGridModal}">
        <div @click="$emit('closeJetplanWaitingRequestsGridModal')" class="modal-background"></div>
        <div class="modal-card  animate__animated animate__zoomIn animate__faster" style="width: 70%;height: 90%">
            <header class="modal-card-head">
                <p class="modal-card-title"></p>
                <button class="delete is-large" @click="$emit('closeJetplanWaitingRequestsGridModal')" aria-label="close">
                </button>
            </header>
            <section class="modal-card-body">
                <div class="object-render-table has-text-centered" style="width: 100%; ">
                    <table class="table is-hoverable is-fullwidth is-narrow is-striped is-bordered is-center">
                        <thead>
                        <tr>
                            <th scope="col">JSummaryId</th>
                            <th scope="col">STD</th>
                            <th scope="col">ProTime</th>
                            <th scope="col">FKeyForZip</th>
                            <th scope="col">JLVT</th>
                            <th scope="col">WLVT</th>
                            <th scope="col">KeyForSearchForRaimPrediction</th>
                            <th scope="col">Main6ByEnumOrder</th>
                            <th scope="col">FIRAerospaces</th>
                            <th scope="col">NotamSubjectList</th>
                            <th scope="col">LastRunUTC</th>
                            <th scope="col">WHICH_CASE</th>
                            <th scope="col">WEATHERCHART_FIRAeroSpaces</th>
                            <th scope="col">WHICH_CASE_INT</th>
                        </tr>
                        </thead>
                        <tbody v-if="waitinglistBridge.length > 0">

                        <tr v-for="item in waitinglistBridge" :key="item.JSummaryId">

                            <td>{{item.jSummaryId}}</td>
                            <td>{{item.std|longFormatFromDT}}</td>
                            <td>{{item.proTime|longFormatFromDT}}</td>

                            <td>{{item.fKeyForZip}}</td>
                            <td>{{item.jlvt}}</td>
                            <td>{{item.wlvt}}</td>

                            <td>{{item.keyForSearchForRaimPrediction}}</td>
                            <td>{{item.main6ByEnumOrder}}</td>
                            <td>{{item.firAerospaces}}</td>

                            <td>{{item.notamSubjectList.substring(0, 50)}}</td>
                            <td>{{item.lastRunUTC|longFormatFromDT}}</td>
                            <td>{{item.whicH_CASE}}</td>

                            <td>{{item.weathercharT_FIRAeroSpaces}}</td>
                            <td>{{item.whicH_CASE_INT}}</td>

                        </tr>



                        </tbody>
                        <div v-else>
                            <p>There is no process for jetplan yet.</p>
                        </div>
                    </table>
                </div>

            </section>
            <footer class="modal-card-foot">

            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: "JetplanWaitingRequestsGridModal",

        data() {
            return {

                    WaitingList:
                    [
                        {"JSummaryId":23896,"STD":"2022-04-04 08:50:00.000","ProTime":"2022-04-03 20:47:04.183","FKeyForZip":"TCCOE_CAI1722_20220404_EDDR_LTAI","JLVT":"4","WLVT":"6","KeyForSearchForRaimPrediction":"004428_EDDR_LTAI_20220404_CAI","Main6ByEnumOrder":"01_EDDR,02_LTAI,03_LTBS","FIRAerospaces":"EDGG,LSAS,LOVV,EDUU,LIMM,LJLA,LDZO,LQSB,LYBA,BKPR,LWSS,LGGG,LTBB,LTAA","NotamSubjectList":"A1585/22éAirport DME WITH ILS|A1307/22éAirport AERODROME|A1252/22éAirport MISSED APPROACH PROCEDURE|A1251/22éAirport INSTRUMENT APPROACH PROCEDURE|A1250/22éAirport SID|A0346/22éAirport LOCATOR OUTER ILS|A2021/22éAirport RWY|A1052/22éAirport AERODROME|D0687/22éAirport RWY ARRESTING GEAR|V0015/22éAirport INSTRUMENT APPROACH PROCEDURE|D1460/21éAirport FUEL AVAILABILITY|D1459/21éAirport AERODROME|D1458/21éAirport AERODROME|A1063/22éAirport AERODROME|D1905/21éAirport RWY ARRESTING GEAR|D1904/21éAirport AERODROME|","LastRunUTC":"2022-04-04 08:00:44.793","WHICH_CASE":"IN LAST 30MIN PERIOD","WEATHERCHART_FIRAeroSpaces":"EDDR,LTAI,EDGG,LSAS,LOVV,EDUU,LIMM,LJLA,LDZO,LQSB,LYBA,BKPR,LWSS,LGGG,LTBB,LTAA","WHICH_CASE_INT":"2"},
                        {"JSummaryId":23900,"STD":"2022-04-04 09:15:00.000","ProTime":"2022-04-03 22:42:04.007","FKeyForZip":"TCCON_CAI1408_20220404_EDDL_LTAI","JLVT":"1","WLVT":"4","KeyForSearchForRaimPrediction":"004445_EDDL_LTAI_20220404_CAI","Main6ByEnumOrder":"01_EDDL,02_LTAI,03_LTBS","FIRAerospaces":"EDGG,EDUU,LOVV,LJLA,LDZO,LYBA,LBSR,LGGG,LTBB,LTAA","NotamSubjectList":"A1563/22éAirport SID|A1537/22éAirport TAXIWAY|A1536/22éAirport ACFT STANDS|A1535/22éAirport FUEL AVAILABILITY|A1534/22éAirport RWY|A1435/22éAirport STAR|A1434/22éAirport SID|A1433/22éAirport MISSED APPROACH PROCEDURE|A1432/22éAirport INSTRUMENT APPROACH PROCEDURE|A1356/22éAirport VOR/DME|A1092/22éAirport OBSTACLE|A0940/22éAirport DME WITH ILS|A0829/22éAirport OBSTACLE|A0669/22éAirport TAXIWAY|A0610/22éAirport TAXIWAY|W0752/22éAirport AERONAUTICAL INFORMATION SERVICE|A2021/22éAirport RWY|A1052/22éAirport AERODROME|D0687/22éAirport RWY ARRESTING GEAR|V0015/22éAirport INSTRUMENT APPROACH PROCEDURE|D1460/21éAirport FUEL AVAILABILITY|D1459/21éAirport AERODROME|D1458/21éAirport AERODROME|A1063/22éAirport AERODROME|D1905/21éAirport RWY ARRESTING GEAR|D1904/21éAirport AERODROME|","LastRunUTC":"2022-04-04 07:52:17.543","WHICH_CASE":"IN LAST 150 Minutes (B)","WEATHERCHART_FIRAeroSpaces":"EDDL,LTAI,EDGG,EDUU,LOVV,LJLA,LDZO,LYBA,LBSR,LGGG,LTBB,LTAA","WHICH_CASE_INT":"5"}
                    ],






            }
        },

        props: ['isActiveJetplanWaitingRequestsGridModal','waitinglistBridge'],

        async created() {
            this.WaitingList = this.waitinglistBridge;

        },

        mounted()
        {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27) { //ESC
                    this.$emit('closeJetplanWaitingRequestsGridModal');
                }
            })
        },

                    // Api deki komutu eklemeden data gelsin .
                    // Bu modalı başka bir yere eklemesine bakalım .
                    // butonu ekleyince açılsın ....

        methods:
        {

        }
    }
</script>

<style scoped>

    .object-render-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 17px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .object-render-table td {
        border: 0px;
    }

    .object-render-table {
        overflow-y: scroll;
        height: 100%;
        width: 100%;
        position: center;
        display: block;
    }

    .object-render-table th {
        top: -12px;
        position: sticky;
        background-color: white;
        z-index: 2;
    }

</style>
